import React, { useEffect } from 'react';
import { Navigate, Outlet, useNavigate } from 'react-router-dom';

function PrivateRoute(props) {
  // const token = localStorage.getItem('token');
  // const isAuthenticated = token !== null && token !== 'undefined';
  // return isAuthenticated ? <Outlet /> : <Navigate to="/login" replace />;
  const navigate = useNavigate();
  const { component: Component, ...rest } = props; 

  useEffect(() => {
    const auth = localStorage.getItem('token') !== null;
    if (!auth || auth === 'undefined') {
      navigate('/');
    }
  }, [navigate]);

  return <Component {...rest} />;
}

export default PrivateRoute;

